import React from 'react';
import moment from 'moment';
import { DatePickerInput } from 'rc-datepicker';

// two linked date select inputs, constrained such that the start must be before
// the end
export default class DateRange extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      start: this.props.startDefault || this.props.start,
      end: this.props.endDefault || this.props.end,
    };
  }
  formatDateForAPI(date){
    return moment(date).format('YYYY-MM-DD');
  }
  updateStart(newStart){
    this.props.onChange({
      start: this.formatDateForAPI(newStart),
      end: this.formatDateForAPI(this.state.end),
    });
    this.setState({
      start: newStart
    });
  }
  updateEnd(newEnd){
    this.props.onChange({
      start: this.formatDateForAPI(this.state.start),
      end: this.formatDateForAPI(newEnd),
    });
    this.setState({
      end: newEnd
    });
  }
  render(){
    return(
      <div className="dateRange">
        <div className="subLabel">{this.props.startLabel}</div>
        <DatePickerInput
          key={"calstart"}
          name="Start"
          value={this.state.start}
          minDate={this.props.start}
          maxDate={this.props.end}
          onChange={this.updateStart.bind(this)}
          className="start"
        />
        <div className="subLabel">{this.props.endLabel}</div>
        <DatePickerInput
          key={"calend"}
          name="End"
          value={this.state.end}
          minDate={this.props.start}
          maxDate={this.props.end}
          onChange={this.updateEnd.bind(this)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/DateRange.js